import React, { useEffect, useState } from "react";
import ModalBackground from "./modalbackground";

const SideModalcontainer = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(true);
  }, []);
  return (
    <div>
      <div>
        <ModalBackground>
          <div className={`flex min-h-screen justify-end`}>
            <div
              className={`bg-white w-96 h-screen transform transition-transform duration-500 ease-in-out overflow-y-scroll  ${
                isOpen ? "translate-x-0" : "translate-x-full"
              }`}
            >
              {children}
            </div>
          </div>
        </ModalBackground>
      </div>
    </div>
  );
};
export const SideModalContainerNew = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(true);
  }, []);

  return (
    <div>
      <ModalBackground>
        <div className={`flex min-h-screen justify-end`}>
          <div
            className={`bg-white max-w-2xl h-screen transform transition-transform duration-500 ease-in-out overflow-y-scroll ${
              isOpen ? "translate-x-0" : "translate-x-full"
            }`}
          >
            {children}
          </div>
        </div>
      </ModalBackground>
    </div>
  );
};

export default SideModalcontainer;
